/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

export const createc_bridge = (block, generator) => ['EstadoPuente()', generator.ORDER_ATOMIC];

export const createc_ship = (block, generator) => ['EstadoBarco()', generator.ORDER_ATOMIC];

export const createc_logic_compare_bridge = (block, generator) => {
  const state = block.getFieldValue('STATE') || '';
  const order = generator.ORDER_RELATIONAL;
  const argument0 = generator.valueToCode(block, 'A', order) || '';
  return [`${argument0} == ${state}`, order];
};

export const createc_logic_compare_ship = (block, generator) => {
  const state = block.getFieldValue('STATE') || '';
  const order = generator.ORDER_RELATIONAL;
  const argument0 = generator.valueToCode(block, 'A', order) || '';
  return [`${argument0} == ${state}`, order];
};

// El valor del dropdown ya es la llamada C++ ('AbrirPuente()'); solo se agrega
// el ';', como en el legacy.
export const createc_open_puente_mujer = (block) => {
  const estado = block.getFieldValue('STAT');
  return `${estado};\n`;
};

export const createc_puente_mujer = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.createc_puente_mujer = '\ncheckPuente();\n';
  return `prenderLucesPuente(${color});\n`;
};

export const createc_puente_mujer_off = (block, generator) => {
  generator.loop_footer_.createc_puente_mujer = '\ncheckPuente();\n';
  return 'apagarLucesPuente();\n';
};

export const createc_luces_dique3 = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.createc_luces_dique3 = '\ncheckDique();\n';
  return `prenderLucesDique(${color});\n`;
};

export const createc_luces_dique3_off = (block, generator) => {
  generator.loop_footer_.createc_luces_dique3 = '\ncheckDique();\n';
  return 'apagarLucesDique();\n';
};

export const createc_luminaria_zona1 = (block) => {
  const estado = block.getFieldValue('STAT');
  return `LuminariaCalle(${estado});\n`;
};

export const createc_senda_peatonal = (block, generator) => {
  const color = generator.valueToCode(block, 'COLOUR', generator.ORDER_ATOMIC) || 0;
  generator.loop_footer_.createc_senda_peatonal = '\ncheckSenda();\n';
  return `prenderLucesSenda(${color});\n`;
};

export const createc_senda_peatonal_off = (block, generator) => {
  generator.loop_footer_.createc_senda_peatonal = '\ncheckSenda();\n';
  return 'apagarLucesSenda();\n';
};
